import { confirmSignUp } from "aws-amplify/auth";
import { useEffect, useState } from "react";

export default function ConfirmSignUp({ onSuccess, onBackToLogin }) {
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const [isConfirmed, setIsConfirmed] = useState(false);

  useEffect(() => {
    const container = document.querySelector(
      ".greenone-confirm-sign-up"
    );

    if (!container) {
      return undefined;
    }

    function styleSdxButton(button) {
      const shadowRoot = button.shadowRoot;

      if (
        !shadowRoot ||
        shadowRoot.querySelector(
          "[data-greenone-confirm-button-styles]"
        )
      ) {
        return;
      }

      const style = document.createElement("style");

      style.setAttribute(
        "data-greenone-confirm-button-styles",
        "true"
      );

      style.textContent = `
        button,
        button.primary {
          background: #005654 !important;
          border-color: #005654 !important;
          color: #fff !important;
        }

        button:hover,
        button.primary:hover {
          background: #026F6D !important;
          border-color: #026F6D !important;
          color: #fff !important;
        }

        button:focus-visible,
        button.primary:focus-visible {
          outline: 3px solid #005654 !important;
          outline-offset: 2px !important;
        }
      `;

      shadowRoot.appendChild(style);
    }

    function styleSdxInput(input) {
      const shadowRoot = input.shadowRoot;

      if (
        !shadowRoot ||
        shadowRoot.querySelector(
          "[data-greenone-confirm-input-styles]"
        )
      ) {
        return;
      }

      const style = document.createElement("style");

      style.setAttribute(
        "data-greenone-confirm-input-styles",
        "true"
      );

      style.textContent = `
        input:focus,
        input:focus-visible {
          border-color: #026F6D !important;
          outline-color: #026F6D !important;
          box-shadow: 0 0 0 1px #026F6D !important;
        }

        :host(:focus-within) input {
          border-color: #026F6D !important;
          outline-color: #026F6D !important;
          box-shadow: 0 0 0 1px #026F6D !important;
        }
      `;

      shadowRoot.appendChild(style);
    }

    function applyComponentStyles() {
      container
        .querySelectorAll("sdx-button")
        .forEach(styleSdxButton);

      container
        .querySelectorAll("sdx-input")
        .forEach(styleSdxInput);
    }

    applyComponentStyles();

    const observer = new MutationObserver(
      applyComponentStyles
    );

    observer.observe(container, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  const handleConfirm = async (e) => {
    e.preventDefault();
    setError(null);
    setMessage(null);
    try {
      await confirmSignUp({
        username: email, // Cognito erwartet "username" = Email
        confirmationCode: code,
      });
      setIsConfirmed(true);
      setError(null);
      setMessage(
        "Ihr Konto wurde erfolgreich bestätigt. Sie können sich nun mit Ihrer E-Mail-Adresse und Ihrem Passwort anmelden."
      );
    } catch (err) {
      console.error("ConfirmSignUp failed:", err);
      const errorMessages = {
        CodeMismatchException: "Der Bestätigungscode ist ungültig. Bitte überprüfen Sie Ihre Eingabe.",
        ExpiredCodeException: "Der Bestätigungscode ist abgelaufen. Bitte fordern Sie einen neuen Code an.",
        LimitExceededException: "Zu viele Versuche. Bitte versuchen Sie es später erneut.",
        TooManyRequestsException: "Zu viele Anfragen. Bitte versuchen Sie es später erneut.",
        UserNotFoundException: "Für diese E-Mail-Adresse wurde kein Konto gefunden.",
        NotAuthorizedException: "Das Konto kann nicht bestätigt werden. Falls es bereits bestätigt ist, melden Sie sich bitte an.",
      };
      setError(errorMessages[err.name] || "Die Bestätigung ist fehlgeschlagen. Bitte versuchen Sie es erneut.");
    }
  };

  return (
    <div
      className="sdx greenone-confirm-sign-up"
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        overflow: "hidden",
        padding: "1.5rem",
        boxSizing: "border-box",
      }}
    >
      {/* Hintergrundbild mit Blur */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url('/images/Garage_2.png')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "blur(8px) brightness(0.55)",
          transform: "scale(1.05)",
        }}
      ></div>

      {/* Confirm-Box */}
      <div
        style={{
          position: "relative",
          background: "rgba(255, 255, 255, 0.97)",
          borderRadius: "16px",
          padding: "2rem",
          width: "100%",
          maxWidth: "400px",
          boxShadow: "0 24px 60px rgba(15, 23, 42, 0.28)",
          border: "1px solid #b7cfcc",
          boxSizing: "border-box",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "0.5rem", color: "#004A53" }}>
          Konto bestätigen
        </h2>
        <p style={{ textAlign: "center", marginBottom: "1.5rem", color: "#64748b" }}>
          Geben Sie den Bestätigungscode ein, den Sie per E-Mail erhalten haben.
        </p>

        {!isConfirmed ? (
          <form onSubmit={handleConfirm} style={{ display: "grid", gap: "1rem" }}>
            <sdx-input
              label="E-Mail"
              type="email"
              placeholder="Geben Sie Ihre E-Mail ein"
              value={email}
              onInput={(e) => setEmail(e.target.value)}
              required
            ></sdx-input>

            <sdx-input
              label="Bestätigungscode"
              placeholder="Geben Sie den Code ein"
              value={code}
              onInput={(e) => setCode(e.target.value)}
              required
            ></sdx-input>

            {error && <p style={{ color: "red", fontSize: "0.9rem" }}>{error}</p>}

            <sdx-button type="submit" variant="primary" label="Bestätigen"></sdx-button>
          </form>
        ) : (
          <div style={{ display: "grid", gap: "1rem" }}>
            <div
              style={{
                padding: "1rem",
                borderRadius: "12px",
                background: "#f0fdf4",
                border: "1px solid #bbf7d0",
                color: "#166534",
                fontSize: "0.95rem",
                lineHeight: 1.6,
              }}
            >
              {message}
            </div>

            <sdx-button
              type="button"
              variant="primary"
              label="Zur Anmeldung"
              onClick={() => {
                if (onBackToLogin) onBackToLogin();
              }}
            ></sdx-button>
          </div>
        )}

        {!isConfirmed && (
          <div
            style={{
              marginTop: "1.5rem",
              textAlign: "center",
              fontSize: "0.9rem",
            }}
          >
            <a
              onClick={(e) => {
                e.preventDefault();
                onBackToLogin();
              }}
              style={{ color: "#026F6D", cursor: "pointer" }}
            >
              Zurück zur Anmeldung
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
